// SSE Configuration for Cart - Optimized for 2000+ concurrent users
export const SSE_CONFIG = {
  // Reduce client-side reconnection attempts
  MAX_RECONNECT_ATTEMPTS: 3,
  
  // Increase reconnection delays to reduce server load
  INITIAL_RECONNECT_DELAY: 5000, // 5 seconds (was 2 seconds)
  MAX_RECONNECT_DELAY: 60000, // 1 minute max delay
  
  // Exponential backoff multiplier
  RECONNECT_BACKOFF_MULTIPLIER: 2,
  
  // Connection timeout (how long to wait for connection)
  CONNECTION_TIMEOUT: 15000, // 15 seconds
  
  // Whether to automatically reconnect on error
  AUTO_RECONNECT: true,
  
  // Whether to reconnect when tab becomes visible again
  RECONNECT_ON_FOCUS: false, // Disable to reduce load
  
  // Whether to close connections when tab is hidden
  CLOSE_ON_BLUR: true // Enable to save resources
}

// Enhanced reconnection strategy with exponential backoff
export function calculateReconnectDelay (attempt) {
  const delay = Math.min(
    SSE_CONFIG.INITIAL_RECONNECT_DELAY * Math.pow(SSE_CONFIG.RECONNECT_BACKOFF_MULTIPLIER, attempt),
    SSE_CONFIG.MAX_RECONNECT_DELAY
  )
  
  // Add jitter to prevent thundering herd
  const jitter = Math.random() * 1000
  return delay + jitter
}

// Check if we should attempt reconnection
export function shouldReconnect (attempt, isOnline = navigator.onLine) {
  return (
    SSE_CONFIG.AUTO_RECONNECT &&
    attempt < SSE_CONFIG.MAX_RECONNECT_ATTEMPTS &&
    isOnline
  )
}